interface Params {
  file: Blob
  filename: string
}
export const downloadFile = ({ file, filename }: Params) => {
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(new Blob([file]))
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
